import type { GenericArrayOfObjects } from '@/interfaces/api';

export type ClockSpan = {
  start: string;
  end: string;
};

export type Interval = {
  start: Date | string;
  end: Date | string;
};

export enum UserRole {
  OWNER = 'role_owner',
  ADMIN = 'role_admin',
  OPERATOR = 'role_operator',
  ATTENDANT = 'role_attendant',
  SPECTATOR = 'role_spectator'
}

export interface INovaWarehouse {
  [key: string]: string | null | undefined | GenericArrayOfObjects | string[] | boolean;
  externalId: string;
  externalHeadquartersId: string;
  name: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  timezone: string;
  contactName: string;
  phone: string;
  email: string;
  ccEmails?: string[];
  notes: string;
  instructions: string;
  facilityNumber: string;
  schedule: string;
  orgId?: string;
  wasImportedIntoNova?: string;
  customApptFieldsTemplate?: string | null | undefined | GenericArrayOfObjects;
  allowCarrierScheduling: boolean;
}

export interface INovaSchedule {
  [key: string]: ClockSpan[] | Interval[] | number | undefined;
  version?: number;
  sunday?: ClockSpan[];
  monday?: ClockSpan[];
  tuesday?: ClockSpan[];
  wednesday?: ClockSpan[];
  thursday?: ClockSpan[];
  friday?: ClockSpan[];
  saturday?: ClockSpan[];
  closedIntervals?: Interval[];
}

export interface INovaLoadType {
  [key: string]: string | number | boolean | undefined;
  externalId: string;
  externalWarehouseId: string;
  id?: string;
  name: string;
  direction: string;
  duration_min: number;
  allowCarrierScheduling: boolean;
  orgId?: string;
  wasImportedIntoNova?: string;
  addOn: boolean;
}

export interface INovaDock {
  [key: string]: string | boolean | number | INovaSchedule | string[] | undefined | null;
  externalId: string;
  externalWarehouseId: string;
  externalLoadTypeIds: string;
  id?: string;
  schedule: INovaSchedule | string | null;
  name: string;
  isActive: boolean;
  minCarrierLeadTime_hr?: number;
  allowCarrierScheduling: boolean;
  orgId?: string;
  warehouseId?: string;
  loadTypeIds?: string[];
  wasImportedIntoNova?: string;
  isMapts: boolean;
}

export interface INovaAppointment {
  [key: string]: string | boolean | number | string[] | undefined;
  externalId: string;
  externalWarehouseId: string;
  externalDockId: string;
  externalLoadTypeId: string;
  externalCompanyName?: string;
  externalCustomerId: string;
  externalCreateTimestamp: string;
  status: string;
  start: string;
  end: string;
  refNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  ccEmails: string | string[];
  companyId?: string;
  loadTypeId?: string;
  orgId?: string;
  warehouseId?: string;
  userId?: string;
  phone?: string;
  tags?: string | string[];
  wasImportedIntoNova?: string;
  isRecurring: boolean;
  customFields?: string;
  notes?: string;
}

export interface INovaCarrier {
  [key: string]: string | boolean | number | string[] | undefined;
  companyId: string;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  orgId: string;
  phone: string;
}

export interface INovaUser {
  [key: string]: string | string[] | UserRole | undefined;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  id: string;
  orgId?: string;
  companyId?: string;
}

export interface INovaCarrierData {
  [key: string]: string | string[] | undefined;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  companyId?: string;
  phone?: string;
}
